import React, { useCallback } from "react";
import { registerServiceProviderInformationAction } from "../../../../state/usecase/admin/service_provider/actions";
import { useAppDispatch } from "../../../../state/store";
import { ServiceProviderName } from "../../../../domain/service_provider/ServiceProviderName";
import { ServiceProviderSpId } from "../../../../domain/service_provider/ServiceProviderSpId";
import { ServiceProviderSharedPassword } from "../../../../domain/service_provider/ServiceProviderSharedPassword";
import { AdminServiceProviderEditComponent } from "./AdminServiceProviderEditComponent";
import { useInput } from "../../../hooks/common/useInput";

export function AdminServiceProviderAddPage() {
    const [serviceProviderName, , handleServiceProviderNameChanged] = useInput("");

    const [serviceProviderSpId, , handleSetServiceProviderSpIdChanged] = useInput("");

    const [serviceProviderSharedPassword, , handleSetServiceProviderSharedPasswordChanged] = useInput("");

    const dispatch = useAppDispatch();

    const handleServiceProviderInformationRegisterClicked = useCallback(() => {
        dispatch(registerServiceProviderInformationAction({
            serviceProviderName: ServiceProviderName.fromString(serviceProviderName),
            serviceProviderSpId: ServiceProviderSpId.fromString(serviceProviderSpId),
            serviceProviderSharedPassword: ServiceProviderSharedPassword.fromString(serviceProviderSharedPassword)
        }));
    }, [dispatch, serviceProviderName, serviceProviderSharedPassword, serviceProviderSpId]);

    return (
        <AdminServiceProviderEditComponent
            category="登録"
            serviceProviderName={serviceProviderName}
            serviceProviderSpId={serviceProviderSpId}
            serviceProviderSharedPassword={serviceProviderSharedPassword}
            handleServiceProviderNameChanged={handleServiceProviderNameChanged}
            handleSetServiceProviderSpIdChanged={handleSetServiceProviderSpIdChanged}
            handleSetServiceProviderSharedPasswordChanged={handleSetServiceProviderSharedPasswordChanged}
            handleServiceProviderUpsertClicked={handleServiceProviderInformationRegisterClicked}
        />
    );
}
